<template>
    <div class="sz-index">
        <!-- <RobotSocket ref="robotSocketRef" :nowTime='nowTime' @backSockertData='doSocker($event)' /> -->
        <div class="heard">
            <div class="title-img"><img :src="titleUrl" alt="" /></div>
            <div class="title">{{ infoName }}</div>
            <div class="title-time">
                <el-radio-group v-model="tabPosition">
                    <el-radio-button label="month">月</el-radio-button>
                    <el-radio-button label="season">季</el-radio-button>
                    <el-radio-button label="year">年</el-radio-button>
                </el-radio-group>

                <el-select v-if="tabPosition === 'year'" v-model="selectValue" @change="selectChange(selectValue)" placeholder="请选择年份">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <div class="time-ll">
                    {{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}
                </div>
                <div class="time-li">
                    <div style="text-align: right;">
                        <span v-if="newTime.getDay() === 0">星期日</span>
                        <span v-else-if="newTime.getDay() === 1">星期一</span>
                        <span v-else-if="newTime.getDay() === 2">星期二</span>
                        <span v-else-if="newTime.getDay() === 3">星期三</span>
                        <span v-else-if="newTime.getDay() === 4">星期四</span>
                        <span v-else-if="newTime.getDay() === 5">星期五</span>
                        <span v-else-if="newTime.getDay() === 6">星期六</span>
                    </div>
                    <div style="margin-top: 5px;">
                        {{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate() }}
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="content-left">
                <div class="content-left-top left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">事件数据统计</div>
                            <div style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;flex-direction: column;">
                              <div style="width: 90%;margin: 0 auto;height: 100%;" id="echar6-1"></div>
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
                <div class="content-left-content left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">各类事件完成率统计</div>
                            <div style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;flex-direction: column;" id="echar6-2">
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
                <div class="content-left-bottom left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">语音播放统计</div>
                            <div style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;flex-direction: column;" id="echar2-1">
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
            </div>
            <div class="content-center">

                <div class="center-top corner-border">
                    <div class="left-li-top" style="font-size: 15px;">运行信息</div>
                    <div style="width: 100%;display: inline-block;height: calc(100% - 45px);">

                        <div style="position: absolute;width: 50%;height: 100%;top: 0px;left: 0;display: flex;align-items: center;justify-content: center;">
                          <div class="runTime">
                              <div class="numberli">{{ parseInt((funNum % 100000)/10000) }}</div>
                              <div class="numberli">{{ parseInt((funNum % 10000)/1000) }}</div>
                              <div class="numberli">{{ parseInt((funNum % 1000)/100) }}</div>
                              <div class="numberli">{{ parseInt((funNum % 100)/10) }}</div>
                              <div class="numberli">{{ parseInt(funNum % 10) }}</div>
                          </div>
                        </div>
                        <div style="position: absolute;width: 50%;height: 100%;top: 0px;right: 0;display: flex;align-items: center;justify-content: center;">
                          <div class="runTime">
                              <div class="numberli">{{ parseInt((mileage % 100000)/10000) }}</div>
                              <div class="numberli">{{ parseInt((mileage % 10000)/1000) }}</div>
                              <div class="numberli">{{ parseInt((mileage % 1000)/100) }}</div>
                              <div class="numberli">{{ parseInt((mileage % 100)/10) }}</div>
                              <div class="numberli">{{ parseInt(mileage % 10) }}</div>
                          </div>
                        </div>
                        <div style="position: absolute;width: 50%;bottom: 10px;left: 0;text-align: center;color: white;font-size: 18px;font-weight: 600;">
                            运行时长（小时）</div>
                        <div style="position: absolute;width: 50%;bottom: 10px;right: 0;text-align: center;color: white;font-size: 18px;font-weight: 600;">
                            运行里程（KM）</div>
                    </div>
                </div>


                <div class="center-bottom corner-border" style="display: block;" ref="adressWrap">

                    <div class="content-div-check"
                        :style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
                        <img :src="backUrl" />
                    </div>
                    <div class="map-btn">
                        <el-button type="primary" icon="el-icon-sort"
                            style="margin-bottom: 0px;-moz-transform:rotate(-90deg);-webkit-transform:rotate(-90deg);"
                            circle @click="ifMapList=!ifMapList"></el-button>
                        <el-button type="success" icon="el-icon-zoom-in" circle @click="mapScale += 0.1"></el-button>
                        <el-button type="danger" icon="el-icon-zoom-out" circle @click="mapScale -= 0.1"></el-button>
                    </div>

                    <el-button type="info" v-if="mapAry.length > 4 && ifMapList" style="position: absolute;left: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle @click="mapScroll('left')">
                      <i class="el-icon-caret-left" style="font-size: 25px;"></i>
                    </el-button>

                    <el-button type="info" v-if="mapAry.length > 4 && ifMapList" style="position: absolute;right: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle @click="mapScroll('right')">
                      <i class="el-icon-caret-right" style="font-size: 25px;"></i>
                    </el-button>

                    <transition name="el-zoom-in-bottom">
                        <div v-show="ifMapList" class="changeImage">
                            <div class="img-li" v-for="(item, index) in mapAry" :key="index"
                                @click="getMapDetail(index)"
                                :style="{backgroundColor: item.check ? '#2b4490' : 'transparent'}">
                                <div class="img-tltle" style="margin-bottom: 10px;">{{ item.rName }}</div>
                                <el-image style="width: 100px; height: 100px" :src="item.address" fit="scale-down">
                                </el-image>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>
            <div class="content-right">
                <div class="content-right-content right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">环境 - 温度 平均值</div>
                            <div style="width: 100%;display: inline-block;height: calc(100% - 45px);" id="echar4-1">
                            </div>
                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
                <div class="content-right-top right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">环境 - 湿度 平均值</div>
                            <div style="width: 100%;display: inline-block;height: calc(100% - 45px);" id="echar3-1">
                            </div>
                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
                <div class="content-right-bottom right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">环境 - PM2.5 平均值</div>
                            <div style="width: 100%;display: inline-block;height: calc(100% - 45px);" id="echar5-1">
                            </div>
                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped lang="less">
    .heard /deep/ .el-radio-button__inner {
        background-color: rgb(27, 31, 61);
        padding: 10px 16px;
        border: none;
        color: white;
    }
    .heard /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        color: #FFF;
        background-color: #409EFF;
        border-color: #409EFF;
    }
    .heard /deep/ .el-select {
      width: 120px;
      margin-left: 15px;
    }
    .heard /deep/ .el-input__inner {
      height: 30px;
    }
    .heard /deep/ .el-input__icon {
      line-height: 30px;
    }
    .heard /deep/ .el-select-dropdown__item {
      height: 30px;
      line-height: 30px;
    }
</style>

<script>
    import {
        mapList,
        rIndex,
    } from '@/api/index'
    import {
        tenantInfoName,
        environLineChart,
        eventTypeChart,
        eventFinishBarChart,
        runTimeMileage,
        voiceChart
    } from '@/api/customIndex'
    import {
        getItem
    } from '@/utils/auth'
    import RobotSocket from '@/components/RobotSocket.vue'
    import '@/page/customIndex/szIndex/index.less'

    export default {
        name: 'statistics',
        components: {
            RobotSocket
        },
        data() {
            return {
                options: [],
                selectValue: '',
                tabPosition: 'month',
                newTime: new Date(),
                nowTime: new Date().getTime(),
                titleUrl: require('../../../../static/img/title.png'),
                backUrl: '',
                mapAry: [],
                mapRobotColor: ['#FF6600', '#FFFF66', '#336699', '#CC6699', '#FF9933', '#FFFFCC', '#009966', '#663300'],
                vWidth: 0,
                vHeight: 0,
                ifMapList: false,
                mapScale: 1,
                funNum: 0,
                mileage: 0,
                checkMap: {},
                infoName: ""
            }
        },
        mounted() {
            // 定时执行保持token有效
            let that = this
            setInterval(() => {
                that.newTime = new Date()
            }, 1000)
            setInterval(() => {
                rIndex()
            }, 1000 * 60 * 60 * 5)

            for(let i = 0;i < 3;i++) {
              that.options.push({
                value: Number(that.newTime.getFullYear()) - i,
                label: Number(that.newTime.getFullYear()) - i
              })
            }
            that.selectValue = that.newTime.getFullYear()
            that.mapList(getItem('tenantInfoId'))
            that.tenantInfoName(getItem('tenantInfoId'))
        },
        methods: {
            mapScroll(type) {
              let leftData = document.getElementsByClassName('changeImage')[0].scrollLeft
              if (type === 'left') {
                document.getElementsByClassName('changeImage')[0].scrollLeft = leftData - 100
              } else {
                document.getElementsByClassName('changeImage')[0].scrollLeft = leftData + 100
              }
            },
            selectChange(val) {
              this.runAjax(getItem('tenantInfoId'), '3&year=' + val)
            },
            tenantInfoName(id) {
                let that = this
                tenantInfoName(id).then(res => {
                    that.infoName = res.data.tenantInfoName
                })
            },
            eventTypeChart(id, type) {
              let that = this
              eventTypeChart(id, type).then(res => {
                if(res.data) {
                  that.Echarts61(res.data)
                }
              })
            },
            environLineChart(id, type) {
              let that = this
              environLineChart(id, type).then(res => {
                if (res.data) {
                  // 环境-湿度
                  that.Echarts31({
                    dateList: res.data.dateList,
                    humidity:res.data.humidity
                  })
                  // 环境-温度
                  that.Echarts41({
                    dateList: res.data.dateList,
                    temperature:res.data.temperature
                  })
                  // 环境-PM2.5
                  that.Echarts51({
                    dateList: res.data.dateList,
                    pm2_5:res.data.pm2_5
                  })
                }
              })
            },
            eventFinishBarChart(id, type) {
              let that = this
              eventFinishBarChart(id, type).then(res => {
                if (res.data) {
                  that.Echarts62(res.data)
                }
              })
            },
            runTimeMileage(id, type) {
              let that = this
              runTimeMileage(id, type).then(res => {
                if (res.data) {
                  that.funNum = Number(res.data.times)
                  that.mileage = Number(res.data.mileage)
                }
              })
            },
            voiceChart(id, type) {
              let that = this
              voiceChart(id, type).then(res => {
                if (res.data) {
                  that.Echarts21(res.data)
                }
              })
            },
            Echarts21(echarArray) {
              var myChart = this.$echarts.init(document.getElementById('echar2-1'))
              myChart.clear();
              let xData = []
              let yData = []
              echarArray.forEach(res => {
                  xData.push(res.day)
                  yData.push(res.num)
              })
              let option = {
                  xAxis: {
                      type: 'category',
                      data: xData,
                      axisLabel: {
                          rotate: 30,
                          show: true,
                          textStyle: {
                              color: 'rgb(110,112,121)'
                          },
                          fontSize: 14
                      }
                  },
                  yAxis: {
                      type: 'value',
                      axisLabel: {
                          show: true,
                          textStyle: {
                              color: 'rgb(110,112,121)'
                          },
                          fontSize: 14,
                          formatter: '{value}次'
                      }
                  },
                  grid: {
                      top: '10%',
                      left: '2%',
                      bottom: '2%',
                      right: '1%',
                      containLabel: true,
                  },
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross'
                      },
                      formatter: function(params) {
                          var html = params[0].name + "<br>";
                          for (var i = 0; i < params.length; i++) {
                              html += params[i].marker + '播放: ' + params[i].value + '次';
                          }
                          return html + "<br>";
                      }
                  },
                  series: [{
                      data: yData,
                      type: 'bar',
                      backgroundStyle: {
                          color: 'rgba(180, 180, 180, 0.2)'
                      },
                      itemStyle: {
                          normal: {
                              color: function(params) {
                                  var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300',
                                      'rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                          '#CC6699',
                                          '#FFFFCC', '#009966', '#663300','rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300'
                                  ]
                                  return colorList[params.dataIndex]
                              },
                              label: {
                                  show: true,
                                  formatter: '{c}次',
                                  position: 'top',
                                  fontWeight: 600,
                                  fontSize: 15
                              }
                          }
                      }
                  }]
              };
              myChart.setOption(option, true)
            },
            Echarts51(echarArray) {
              var myChart = this.$echarts.init(document.getElementById('echar5-1'))
              myChart.clear();
              let newLineData = []
              if (echarArray.pm2_5.length === 0) {
                  let aaalist = []
                  echarArray.dateList.forEach(rv => {
                      aaalist.push(0)
                  })
                  newLineData.push({
                      name: '',
                      data: aaalist,
                      type: "line",
                      label: {
                          show: true,
                          position: 'top'
                      }
                  })
              } else {
                  newLineData.push({
                      name: "PM2.5统计",
                      data: echarArray.pm2_5,
                      type: "line",
                      markPoint: {
                        data: [
                          { type: 'max', name: 'Max' },
                          { type: 'min', name: 'Min' }
                        ]
                      },
                      markLine: {
                        data: [
                          {
                            silent: false,
                            yAxis: 50,
                            type: 'average',
                            name: 'Avg',
                            lineStyle: { type: 'dashed', color: '#ffffc5', width: 3 },
                            label: {
                              color: '#ffffc5',
                              formatter: "优"
                            }
                          },
                          {
                            silent: false,
                            yAxis: 100,
                            type: 'average',
                            name: 'Avg',
                            lineStyle: { type: 'dashed', color: '#ffffc5', width: 3 },
                            label: {
                              color: '#ffffc5',
                              formatter: "良"
                            }
                          },
                          {
                            silent: false,
                            yAxis: 150,
                            type: 'average',
                            name: 'Avg',
                            lineStyle: { type: 'dashed', color: '#ffffc5', width: 3 },
                            label: {
                              color: '#ffffc5',
                              formatter: "差"
                            }
                          }
                        ]
                      },
                      itemStyle: {
                          normal: {
                              label: {
                                  show: false,
                                  formatter: '{c}μg/m³',
                                  position: 'top',
                                  fontWeight: 600,
                                  fontSize: 14
                              }
                          }
                      },
                      label: {
                          show: true,
                          position: 'top'
                      }
                  })
              }

              var option = {
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross'
                      },
                      formatter: function(params) {
                          var html = params[0].seriesName + "<br>";
                          for (var i = 0; i < params.length; i++) {
                              html += params[i].marker + params[i].axisValue + " " + params[i].value + 'μg/m³';
                          }
                          return html + "<br>";
                      }
                  },
                  grid: {
                      top: '10%',
                      left: '3%',
                      right: '5%',
                      bottom: '2%',
                      containLabel: true
                  },
                  xAxis: {
                      type: 'category',
                      boundaryGap: false,
                      axisLabel: {
                          rotate: 40
                      },
                      data: echarArray.dateList
                  },
                  yAxis: {
                      type: 'value',
                      min: Math.min(...echarArray.pm2_5) - 5,
                      max: 150,
                      axisLabel: {
                          formatter: '{value} μg/m³'
                      }
                  },
                  series: newLineData
              };
              myChart.setOption(option)
            },
            // 温度
            Echarts41(echarArray) {
              var myChart = this.$echarts.init(document.getElementById('echar4-1'))
              myChart.clear();
              let newLineData = []
              if (echarArray.temperature.length === 0) {
                  let aaalist = []
                  echarArray.dateList.forEach(rv => {
                      aaalist.push(0)
                  })
                  newLineData.push({
                      name: '',
                      data: aaalist,
                      type: "line",
                      label: {
                          show: true,
                          position: 'top'
                      }
                  })
              } else {
                  newLineData.push({
                      name: "温度统计",
                      data: echarArray.temperature,
                      type: "line",
                      markPoint: {
                        data: [
                          { type: 'max', name: 'Max' },
                          { type: 'min', name: 'Min' }
                        ]
                      },
                      itemStyle: {
                          normal: {
                              label: {
                                  show: false,
                                  formatter: '{c}°C',
                                  position: 'top',
                                  fontWeight: 600,
                                  fontSize: 14
                              }
                          }
                      },
                      label: {
                          show: true,
                          position: 'top'
                      }
                  })
              }

              var option = {
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross'
                      },
                      formatter: function(params) {
                          var html = params[0].seriesName + "<br>";
                          for (var i = 0; i < params.length; i++) {
                              html += params[i].marker + params[i].axisValue + " " + params[i].value + '°C';
                          }
                          return html + "<br>";
                      }
                  },
                  grid: {
                      top: '10%',
                      left: '3%',
                      right: '4%',
                      bottom: '2%',
                      containLabel: true
                  },
                  xAxis: {
                      type: 'category',
                      boundaryGap: false,
                      axisLabel: {
                          rotate: 40
                      },
                      data: echarArray.dateList
                  },
                  yAxis: {
                      type: 'value',
                      min: Math.min(...echarArray.temperature) - 5,
                      max: Math.max(...echarArray.temperature) + 5,
                      axisLabel: {
                          formatter: '{value} °C'
                      }
                  },
                  series: newLineData
              };
              myChart.setOption(option)
            },
            // 湿度
            Echarts31(echarArray) {
              var myChart = this.$echarts.init(document.getElementById('echar3-1'))
              myChart.clear();
              let newLineData = []
              if (echarArray.humidity.length === 0) {
                  let aaalist = []
                  echarArray.dateList.forEach(rv => {
                      aaalist.push(0)
                  })
                  newLineData.push({
                      name: '',
                      data: aaalist,
                      type: "line",
                      label: {
                          show: true,
                          position: 'top'
                      }
                  })
              } else {
                  newLineData.push({
                      name: "湿度统计",
                      data: echarArray.humidity,
                      type: "line",
                      markPoint: {
                        data: [
                          { type: 'max', name: 'Max' },
                          { type: 'min', name: 'Min' }
                        ]
                      },
                      label: {
                          show: true,
                          position: 'top'
                      },
                      itemStyle: {
                          normal: {
                              label: {
                                  show: false,
                                  formatter: '{c}RH',
                                  position: 'top',
                                  fontWeight: 600,
                                  fontSize: 14
                              }
                          }
                      }
                  })
              }

              var option = {
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross'
                      },
                      formatter: function(params) {
                          var html = params[0].seriesName + "<br>";
                          for (var i = 0; i < params.length; i++) {
                              html += params[i].marker + params[i].axisValue + " " + params[i].value + 'RH';
                          }
                          return html + "<br>";
                      }
                  },
                  grid: {
                      top: '10%',
                      left: '3%',
                      right: '4%',
                      bottom: '2%',
                      containLabel: true
                  },
                  xAxis: {
                      type: 'category',
                      boundaryGap: false,
                      axisLabel: {
                          rotate: 40
                      },
                      data: echarArray.dateList
                  },
                  yAxis: {
                      type: 'value',
                      min: Math.min(...echarArray.humidity) - 10,
                      max: Math.max(...echarArray.humidity) + 10,
                      axisLabel: {
                          formatter: '{value} RH'
                      }
                  },
                  series: newLineData
              };
              myChart.setOption(option)
            },
            // 事件数据统计
            Echarts61(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar6-1'))
                myChart.clear();
                echarArray.map(v => {
                    v.value = Number(v.num)
                    v.name = v.eName
                })
                var datas = [echarArray]
                var option = {
                    grid: {
                        left: '5%',
                        right: '4%',
                        bottom: '0%',
                        top: '50%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '60%'],
                            center: ["50%", "50%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}}\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15,
                                    },
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: function(params) {
                                        var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                            '#CC6699',
                                            '#FFFFCC', '#009966', '#663300',
                                            'rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                                '#CC6699',
                                                '#FFFFCC', '#009966', '#663300','rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                            '#CC6699',
                                            '#FFFFCC', '#009966', '#663300'
                                        ]
                                        return colorList[params.dataIndex]
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            // 各类事件完成率统计
            Echarts62(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar6-2'))
                myChart.clear();
                let xData = []
                let yData = []
                echarArray.forEach(res => {
                    xData.push(res.name)
                    yData.push(res.completionRate)
                })
                let option = {
                    xAxis: {
                        type: 'category',
                        data: xData,
                        axisLabel: {
                            rotate: 30,
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14,
                            formatter: '{value}%'
                        }
                    },
                    grid: {
                        top: '10%',
                        left: '2%',
                        bottom: '2%',
                        right: '1%',
                        containLabel: true,
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function(params) {
                            var html = params[0].name + "<br>";
                            for (var i = 0; i < params.length; i++) {
                                html += params[i].marker + '完成率: ' + params[i].value + '%';
                            }
                            return html + "<br>";
                        }
                    },
                    series: [{
                        data: yData,
                        type: 'bar',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300',
                                      'rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                          '#CC6699',
                                          '#FFFFCC', '#009966', '#663300','rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300'
                                    ]
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    formatter: '{c}%',
                                    position: 'top',
                                    fontWeight: 600,
                                    fontSize: 15
                                }
                            }
                        }
                    }]
                };
                myChart.setOption(option, true)
            },
            getMapDetail(index) {
                let that = this
                that.mapAry.map(v => {
                    v.check = false
                })
                that.mapAry[index].check = true
                that.checkMap = that.mapAry[index]
                that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
                that.backUrl = that.mapAry[index].address
                that.vWidth = Number(that.mapAry[index].width)
                that.vHeight = Number(that.mapAry[index].height)
                this.computedScale()
            },
            mapList(id) {
                let that = this
                mapList(id).then(res => {
                    if (res.data && res.data.length > 0) {
                        that.mapAry = res.data
                        that.mapAry.map(v => {
                            v.check = false
                        })
                        that.backUrl = that.mapAry[0].address
                        that.vWidth = Number(that.mapAry[0].width)
                        that.vHeight = Number(that.mapAry[0].height)
                        that.getMapDetail(0)
                    } else {
                        that.mapAry = []
                    }
                })
            },
            computedScale() {
                this.mapScale = 1
                this.$nextTick().then(() => {
                    let oW = this.$refs.adressWrap.offsetWidth
                    let oH = this.$refs.adressWrap.offsetHeight
                    if (this.vWidth != oW || this.vHeight != oH) {
                        let wScale = oW / this.vWidth
                        let hScale = oH / this.vHeight
                        this.mapScale = Math.min(wScale, hScale);
                    }
                })
            },
            // 调用数据
            runAjax(tenID, type) {
                let that = this
                that.eventTypeChart(tenID, type)
                that.environLineChart(tenID, type)
                that.eventFinishBarChart(tenID, type)
                that.runTimeMileage(tenID, type)
                that.voiceChart(tenID, type)
            }
        },
        watch: {
            tabPosition: {
                deep: true,
                immediate: true,
                handler(val, oldVal) {
                    if (getItem('userInfo').positionType === '1') {
                        let checkType = ''
                        if (val === 'month') {
                            checkType = '1&year=' + this.newTime.getFullYear()
                        } else if (val === 'season') {
                            checkType = '2&year=' + this.newTime.getFullYear()
                        } else if (val === 'year') {
                            checkType = '3&year=' + this.newTime.getFullYear()
                        }
                        this.runAjax(getItem('tenantInfoId'), checkType)
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/customIndex/szIndex/index.vue